import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { CreatePracticesStyles } from './Style'
import { getBasicTestTakersFetch, getTestTakers3Fetch } from 'store/middlewares/testTakers.crud';
import { queryOptions, useQuery } from '@tanstack/react-query'
import { initialPage, initialPageSize } from 'keys/pagination';
import LearningUnitsAlert from './LearningUnitsAlert';
import qc from 'keys/queryClient'
import CreatePractices from './CreatePractices'

export const CreatePracticesContext = React.createContext()

export const STEPS = {
    SELECT_STUDENT: 'SELECT_STUDENT',
    SELECT_ASSESSMENTS: 'SELECT_ASSESSMENTS',
};

const CreatePracticesPage = () => {
    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)

    const [selectedAssessmentDefs, setSelectedAssessmentDefs] = useState([])
    const [page, setPage] = useState(initialPage)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const [learningUnitsAlert, setLearningUnitsAlert] = useState({
        open: false,
        data: null
    })
    const [selectedTestTaker, setSelectedTestTaker] = useState(null)
    const [currentStep, setCurrentStep] = useState(STEPS.SELECT_STUDENT);

    const hasLearningUnit = headerFilters.learning_group || headerFilters.school_class

    const customFilters = {
        affiliation: headerFilters.affiliation?.id
    }

    const testTakersOptions = queryOptions({
        queryKey: [qc.testTakers, "practices", page, pageSize, sorting, searchVal, headerFilters, testTaker],
        queryFn: async () => {
            const { data } = await getBasicTestTakersFetch({ headerFilters, page, pageSize, search: searchVal, sorting })
            return data
        }
    })

    const testTakers = useQuery(testTakersOptions)

    const commonState = {
        testTakersOptions, testTakers,
        searchVal, setSearchVal,
        sorting, setSorting,
        pageSize, setPageSize,
        page, setPage,
        learningUnitsAlert, setLearningUnitsAlert,
        selectedTestTaker, setSelectedTestTaker,
        currentStep, setCurrentStep,
        selectedAssessmentDefs, setSelectedAssessmentDefs,
        customFilters
    }

    return (
        <CreatePracticesStyles>
            <CreatePracticesContext.Provider value={commonState}>
                <CreatePractices />
                {learningUnitsAlert.open && <LearningUnitsAlert {...learningUnitsAlert?.data} />}
            </CreatePracticesContext.Provider>




            {/* {hasLearningUnit ?
                <CreateAssessments
                    isPractice={true}
                    customFilters={customFilters}
                    showBattery={false}
                /> :
                <div className='select-learning-unit-placeholder'>
                    {"בחר כיתה / קבוצה"}
                </div>} */}
        </CreatePracticesStyles>
    )
}

export default CreatePracticesPage